import { cssClass } from '@/shared/utils'
import React, { ElementType } from 'react'

// This is a component work in progress
//  the goal of this component is to be able to use it like this:
//  <Title as="h1">Hello World</Title>
//  <Title as="h2">Hello World</Title>\
// and reuse the same component for different titles with different sizes and styles

const DEFAULT_PROPS = {
  h3: {
    as: 'h3',
    size: 'text-20 text-30--tablet',
    weight: 'font-medium',
    lineHeight: 'leading-30 leading-44--tablet',
    margin: 'm-0',
    color: 'text-primary',
  },
  regular: {
    as: 'h1',
    size: 'text-20 text-24--tablet',
    weight: 'font-bold',
    lineHeight: 'leading-30 leading-36--tablet',
    margin: 'm-0',
    color: 'text-primary',
  },
  small: {
    as: 'h2',
    size: 'text-16',
    weight: 'font-bold',
    lineHeight: 'leading-24',
    margin: 'm-0',
    color: 'text-primary',
  },
  xSmall: {
    as: 'h2',
    size: 'text-14',
    weight: 'font-bold',
    lineHeight: 'leading-24',
    margin: 'm-0',
    color: 'text-primary',
  },
}

// get variations types from default props
type Variations = keyof typeof DEFAULT_PROPS

interface ITitleProps {
  as?: ElementType
  variation?: Variations
  children: React.ReactNode
  sizeClass?: string
  weightClass?: string
  lineHeightClass?: string
  className?: string
  marginClass?: string
  colorClass?: string
}

export const Title: React.FC<ITitleProps> = ({
  as,
  variation = 'h3', // TODO: joxxe274 change default variation when component is ready
  sizeClass,
  weightClass,
  lineHeightClass,
  marginClass,
  colorClass,
  className,
  children,
}) => {
  const El = as ?? 'h3'
  const size = sizeClass ?? DEFAULT_PROPS[variation].size
  const weight = weightClass ?? DEFAULT_PROPS[variation].weight
  const lineHeight = lineHeightClass ?? DEFAULT_PROPS[variation].lineHeight
  const margin = marginClass ?? DEFAULT_PROPS[variation].margin
  const color = colorClass ?? DEFAULT_PROPS[variation].color

  const classes = cssClass([size, weight, lineHeight, margin, color, className])

  return <El className={classes}>{children}</El>
}
